import { User } from "app/interfaces/i-user-user";
import { LocalStorageService } from "app/services/local-storage/local-storage.service";
import { Tenant } from "./../../../../../interfaces/i-tenant";
import { Component, Inject, OnInit } from "@angular/core";
import {
    UntypedFormControl,
    UntypedFormGroup,
    Validators,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import * as _ from "lodash";

@Component({
  standalone: false,
    selector: "app-edit-privacy",
    templateUrl: "./edit-privacy.component.html",
    styleUrls: ["./edit-privacy.component.scss"],
})
export class DialogEditPrivacyPolicyComponent implements OnInit {
    public formGroup: UntypedFormGroup;
    private tenantSelected: Tenant;
    private user: User;
    private userdata;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<DialogEditPrivacyPolicyComponent>,
        private router: Router,
        private storage: LocalStorageService
    ) {
        this.dialogRef.disableClose = true;
    }

    ngOnInit(): void {
        this.tenantSelected = this.storage.getItem("tenantSelected");
        this.user = this.storage.getItem("user");

        this.userdata = this.data.modalData
            ? this.data.modalData
            : this.user.userdata;
        this.formGroup = new UntypedFormGroup({
            privacy_communications: new UntypedFormControl(
                this.userdata.privacy_communications
            ),
            privacy_third_part: new UntypedFormControl(
                this.userdata.privacy_third_part
            ),
            privacyaccept: new UntypedFormControl(this.userdata.privacyaccept, [
                Validators.required,
            ]),
        });
    }

    navigatePrivacyPolicy() {
        this.dialogRef.close();
        this.router.navigate(["privacy"]);
    }

    onYesClick(): void {
        const updatedData = _.assign({}, this.userdata, this.formGroup.value);
        if (this.tenantSelected?.all_mandatory_privacy) {
            updatedData.privacy_communications = true;
            updatedData.privacy_third_part = true;
            this.formGroup.get("privacy_communications")?.setValue(true);
            this.formGroup.get("privacy_third_part")?.setValue(true);
        }
        setTimeout(() => {
            this.dialogRef.close(updatedData);
        }, 500);
    }
}
